import { useEffect } from 'react';
import { TABS } from '@/constants';
import { formatDateTimeFull } from '@/utils';
import mixpanel from '../../configs/mixpanel';

interface UseLobbyAnalyticsProps {
	activeTab: string;
	lobbyId: string | undefined;
	eventId: string | undefined;
	user: any;
	eventResponse: any;
	lobbyResponse: any;
}

export function useLobbyAnalytics({
	activeTab,
	lobbyId,
	eventId,
	user,
	eventResponse,
	lobbyResponse,
}: UseLobbyAnalyticsProps) {
	useEffect(() => {
		if (user?.email && lobbyId && eventId && eventResponse && lobbyResponse) {
			mixpanel.track('[LOBBY HUB VIEWED]', {
				lobbyId: lobbyId,
				eventId: eventId,
				userEmail: user?.email,
				lobbyName: lobbyResponse?.name,
				eventName: eventResponse?.title,
				timestamp: formatDateTimeFull(Date.now()),
			});
		}
	}, [lobbyId, eventId, lobbyResponse, eventResponse, user?.email]);

	useEffect(() => {
		if (activeTab === TABS.LEADERBOARD) {
			mixpanel.track('[LOBBY LEADERBOARD VIEWED]', {
				lobbyId: lobbyId,
				eventId: eventId,
				userEmail: user?.email,
				tabChangedAt: new Date().toISOString(),
				lobbyName: lobbyResponse?.name,
				eventName: eventResponse?.title,
				timestamp: formatDateTimeFull(Date.now()),
			});
		}
	}, [activeTab, eventId, eventResponse?.title, lobbyId, lobbyResponse?.name, user?.email]);

	useEffect(() => {
		if (activeTab === TABS.MARKETS) {
			mixpanel.track('[MARKETS TAB VIEWED]', {
				lobbyId: lobbyId,
				eventId: eventId,
				userEmail: user?.email,
				tabChangedAt: new Date().toISOString(),
				lobbyName: lobbyResponse?.name,
				eventName: eventResponse?.title,
				timestamp: formatDateTimeFull(Date.now()),
			});
		}
	}, [activeTab, eventId, eventResponse?.title, lobbyId, lobbyResponse?.name, user?.email]);
}
